"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var openModal = function (menu) {
    var $chooseMenu = document.querySelector('.choose__menu');
    $chooseMenu.addEventListener('click', function (e) {
        var _a;
        var target = e.target;
        if (target.matches(".".concat(menu, "__title")) || target.matches(".".concat(menu, "__title > i"))) {
            (_a = document.querySelectorAll('.modal')) === null || _a === void 0 ? void 0 : _a.forEach(function (v) {
                var _a;
                v.classList.toggle('open', v.nextElementSibling === target
                    || ((_a = v.nextElementSibling) === null || _a === void 0 ? void 0 : _a.firstElementChild) === target);
            });
        }
    });
};
exports.default = (function () {
    Promise.all([
        openModal('size'),
        openModal('bread'),
        openModal('meats'),
        openModal('cheese'),
        openModal('veggies'),
        openModal('sauce'),
        openModal('extras'),
    ]);
});
